<template>
  <div class="case-trial">
    <Row class="detail-header">
      <span>庭审</span>
      <Button
        v-if="infoCtrl && isDetailLoad && editState" type="primary"
        style="margin-left: 10px;" @click="infoCtrl=false"
      >修改</Button>
    </Row>
    <Row class="case-content">
      <Row v-if="!infoCtrl && isDetailLoad" class="case-form">
        <Form
          ref="formData" :model="formData"
          :rules="ruleValidate" :disabled="caseState=='TN'"
          :label-width="120"
        >
          <FormItem label="开庭时间" prop="courtTime">
            <Row v-if="defaultData.courtTime ">{{ formData.courtTime }}</Row>
            <DatePicker
              v-else
              transfer
              type="date"
              placeholder="请选择开庭时间"
              style="width:100%"
              format="yyyy-MM-dd"
              :value="formData.courtTime"
              @on-change="getTime"
            />
          </FormItem>
          <FormItem label="原告代理人" prop="courtAgent">
            <Input
              v-model="formData.courtAgent" class="split-input"
              placeholder="姓名(多个以英文逗号隔开)"
            />
          </FormItem>
          <FormItem label="被告代理人" prop="otherAgent">
            <Input
              v-model="formData.otherAgent" class="split-input"
              placeholder="姓名(多个以英文逗号隔开)"
            />
          </FormItem>
          <FormItem label="对方当事人是否到场" prop="litigantArrive">
            <RadioGroup v-model="formData.litigantArrive">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="庭审内容" prop="content">
            <Input
              v-model.trim="formData.content" type="textarea"
              :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写庭审内容"
            />
          </FormItem>
          <FormItem label="庭审资料" prop="attachments">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{}"
              @getFileList="getAttachmentList"
            />
          </FormItem>
          <Row class="detail-btn-box">
            <Button
              type="primary" style="margin-right:10px;"
              :disabled="isSubmit" @click="submitNew"
            >保存</Button>
            <Button @click="infoCtrl=true">取消</Button>
          </Row>
        </Form>
      </Row>
      <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
        <Row><Col span="5" class="left-label">开庭时间：</Col><Col span="16" class="right-content">{{ defaultData.courtTime || "" }}</Col></Row>
        <Row><Col span="5" class="left-label">原告代理人：</Col><Col span="16" class="right-content">{{ defaultData.courtAgent || "" }}</Col></Row>
        <Row><Col span="5" class="left-label">被告代理人：</Col><Col span="16" class="right-content">{{ defaultData.otherAgent || "" }}</Col></Row>
        <Row><Col span="5" class="left-label">对方当事人是否到场：</Col><Col span="16" class="right-content">{{ defaultData.litigantArrive?"是":"否" }}</Col></Row>
        <Row><Col span="5" class="left-label">庭审内容：</Col><Col span="16" class="right-content">{{ defaultData.content }}</Col></Row>
        <Row>
          <Col span="5" class="left-label">庭审资料：</Col>
          <Col span="16" class="right-content">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
      </Row>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['caseId', 'processId', 'editState', 'caseState'],
  data () {
    return {
      infoCtrl: true,
      isDetailLoad: false,
      isSubmit: false,
      defaultList: [],
      formData: {
        courtTime: '',
        courtAgent: '',
        otherAgent: '',
        litigantArrive: 0,
        content: '',
        attachments: []
      },
      ruleValidate: {
        courtTime: [{ required: true, message: '开庭时间不能为空', trigger: 'blur' }],
        courtAgent: [{ max: 64, message: '不能超过64个字符', trigger: 'blur' }],
        otherAgent: [{ max: 64, message: '不能超过64个字符', trigger: 'blur' }],
        content: [{ max: 1024, message: '不能超过1024个字符', trigger: 'blur' }]
      }
    }
  },
  created() {},
  beforeMount() {
    this.getDetail()
    this.getTrialTime()
  },
  mounted() {},
  updated() {},
  methods: {
    // 获取庭审详情
    getDetail() {
      const url = '/business/case/court-trial?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = true
          this.giveDefaultData()
        } else {
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    getTrialTime() {
      const url = `/business/case/court-trial/${this.caseId}/date`
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.formData.courtTime = res.data
        }
      })
    },
    getTime(value) {
      this.formData.courtTime = value
    },
    getAttachmentList(arr) {
      this.formData.attachments = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachments.push(obj)
      })
    },
    submitNew() {
      let url = '/business/case/court-trial'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formData)
      if (this.defaultData) {
        url += `/${this.defaultData.id}`
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    },
    giveDefaultData() {
      this.formData.courtTime = this.defaultData.courtTime || ''
      this.formData.courtAgent = this.defaultData.courtAgent || ''
      this.formData.otherAgent = this.defaultData.otherAgent || ''
      this.formData.litigantArrive = this.defaultData.litigantArrive ? 1 : 0
      this.formData.content = this.defaultData.content || ''
      this.formData.attachments = this.defaultData.attachments || []
      this.defaultList = this.defaultData.attachments || []

      this.isDetailLoad = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../caseCommon.scss';
</style>



// WEBPACK FOOTER //
// src/view/civilCase/caseTrial/index.vue